<div
  class="secondary-popup"
  [ngClass]="data?.classNames"
>
  <div class="body">
    <div class="content-container">
      <ng-container *ngTemplateOutlet="data?.template || defaultTemplate; context: {data: data}"></ng-container>
    </div>
  </div>
  <div
    class="background"
    (click)="hide()"
  ></div>
</div>

<ng-template #defaultTemplate>
  <div class="content">
    <p>{{ data?.content }}</p>
  </div>
</ng-template>